(() => {
  const popupClass = 'io-klaviyo-popup';
  const hiddenClass = 'io-klaviyo-launcher-hidden';
  const klaviyoPattern = /klaviyo|kl-private|kl-teaser|onsite|newsletter|discount/i;
  const launcherPattern = /gift|present|teaser|launcher|coupon|discount|20%|twenty/i;
  const selector = 'iframe,form,aside,section,div,button,[role="button"],[class*="klaviyo"],[id*="klaviyo"],[class*="kl-private"],[id*="kl-private"]';
  const scopes = new Set();
  let scheduled = false;

  const signalText = (element) => [element.id, element.getAttribute('class'),
    ...['aria-label','title','name','src','data-testid','data-test-id'].map(name => element.getAttribute(name))
  ].filter(Boolean).join(' ');

  const flush = () => {
    scheduled = false;
    const candidates = new Set();
    scopes.forEach(scope => {
      if (!scope.isConnected) return;
      if (scope.matches?.(selector)) candidates.add(scope);
      scope.querySelectorAll(selector).forEach(element => candidates.add(element));
    });
    scopes.clear();
    const signals = new WeakMap();
    const hosts = new WeakMap();
    const related = element => {
      if (!element || element === document.body || element === document.documentElement) return false;
      if (!signals.has(element)) signals.set(element, klaviyoPattern.test(signalText(element)) || related(element.parentElement));
      return signals.get(element);
    };
    const fixedHost = element => {
      if (!element || element === document.body || element === document.documentElement) return null;
      if (hosts.has(element)) return hosts.get(element);
      const style = getComputedStyle(element);
      let host = null;
      // Only fixed elements need a geometry read. Cache ancestor results for this batch.
      if (style.position === 'fixed' && (style.bottom !== 'auto' || style.right !== 'auto' || style.left !== 'auto')) {
        const rect = element.getBoundingClientRect();
        if (rect.width > 0 && rect.height > 0 && rect.width <= 170 && rect.height <= 170) host = element;
      }
      host ||= fixedHost(element.parentElement);
      hosts.set(element, host);
      return host;
    };
    const hide = new Set();
    const decorate = new Set();
    // Finish all geometry reads before making any style changes.
    candidates.forEach(element => {
      if (!related(element)) return;
      const host = fixedHost(element);
      if (host && (launcherPattern.test(signalText(element)) || element.tagName === 'IFRAME')) hide.add(host);
      else if (!element.classList.contains(popupClass)) {
        const rect = element.getBoundingClientRect();
        if (rect.width >= 260 || rect.height >= 180) decorate.add(element);
      }
    });
    hide.forEach(element => {
      if (element.classList.contains(hiddenClass)) return;
      element.classList.add(hiddenClass);
      element.setAttribute('aria-hidden', 'true');
      element.style.setProperty('display', 'none', 'important');
      element.style.setProperty('visibility', 'hidden', 'important');
      element.style.setProperty('pointer-events', 'none', 'important');
    });
    decorate.forEach(element => element.classList.add(popupClass));
  };

  const queue = scope => {
    if (!(scope instanceof Element) && scope !== document) return;
    // Coalesce nested additions, while retaining independent popups in the same frame.
    for (const existing of scopes) {
      if (existing === scope || existing.contains(scope)) return;
      if (scope.contains(existing)) scopes.delete(existing);
    }
    scopes.add(scope);
    if (!scheduled) { scheduled = true; requestAnimationFrame(flush); }
  };
  const start = () => {
    queue(document);
    new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        // Scan new subtrees, never an unrelated gallery's entire parent on each update.
        mutation.addedNodes.forEach(node => { if (node instanceof Element) queue(node); });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
